import { Community } from '../models'
import { PublishStateType } from '../util/constants'
import { recordTown } from '../util/recordTown'

export interface Address {
  city?: string
  state?: string
  streetAddress?: string
  streetAddress2?: string
  zipCode?: string
}

export interface Contact {
  email?: string
  name?: string
  phone?: string
}

export interface Media {
  publicId?: string
  type?: string
}

export class Publishable {
  // The record's own town: its first live town, else the first town it was added to (CVL-153).
  get community(): Community | undefined {
    return recordTown(this.communities)
  }
  public communities?: Community[]
  public publishState?: PublishStateType
}
